import { pyApi } from '@/api/request'
import {
  AutoPaperActionResult,
  AutoPaperItem,
  AutoPaperList,
  AutoPaperListParams,
  CreateAutoPaperParams,
  KnowledgePointList,
  KnowledgePointParams,
  QuestionBankCategoryList,
  QuestionBankCategoryParams,
  UpdateAutoPaperParams
} from '../models/auto-paper'

// Apipost: https://docs.apipost.net/docs/detail/632f66713488000
const memberExaminationUrl = '/fairy/api/v2/member_examinations/'

// 创建试卷
export function createAutoPaper(data: CreateAutoPaperParams): Promise<AutoPaperItem> {
  return pyApi({
    method: 'POST',
    url: memberExaminationUrl,
    data
  })
}

// 试卷列表
export function getAutoPaperList(params: AutoPaperListParams = {}): Promise<AutoPaperList> {
  return pyApi({
    method: 'GET',
    url: memberExaminationUrl,
    params
  })
}

// 分类列表
export function getQuestionBankCategories(params: QuestionBankCategoryParams): Promise<QuestionBankCategoryList> {
  return pyApi({
    method: 'GET',
    url: '/fairy/api/v1/question_bank_type/',
    params
  })
}

// 考点列表
export function getKnowledgePoints(params: KnowledgePointParams): Promise<KnowledgePointList> {
  return pyApi({
    method: 'GET',
    url: '/fairy/api/v1/question_bank_knowledge_point/',
    params
  })
}

// 删除试卷
export function deleteAutoPaper(id: string): Promise<AutoPaperActionResult> {
  return pyApi({
    method: 'DELETE',
    url: `${memberExaminationUrl}${id}/`
  })
}

// 收藏试卷
export function favoriteAutoPaper(id: string): Promise<AutoPaperActionResult> {
  return pyApi({
    method: 'POST',
    url: `${memberExaminationUrl}${id}/favorite/`
  })
}

// 取消收藏试卷
export function unfavoriteAutoPaper(id: string): Promise<AutoPaperActionResult> {
  return pyApi({
    method: 'POST',
    url: `${memberExaminationUrl}${id}/unfavorite/`
  })
}

// 修改试卷
export function updateAutoPaper(id: string, data: UpdateAutoPaperParams): Promise<AutoPaperItem> {
  return pyApi({
    method: 'PUT',
    url: `${memberExaminationUrl}${id}/`,
    data
  })
}
